module.exports = __webpack_public_path__ + "img/productImg.4eaf3e2d.png";